import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Tabs from './Tabs';
import List from './List';

import { FILTER_LAYOUT } from '../../utils/constants';

const FilterLayout = ({
    loadFields,
    filterLayout,
    ...otherProps
}) => {

    useEffect(()=>{
        
        loadFields();
        
    }, []);

    return filterLayout === FILTER_LAYOUT.tabs
        ? <Tabs {...otherProps} />
        : <List {...otherProps} />;

};

FilterLayout.propTypes = {
    loadFields: PropTypes.func.isRequired,
    filterLayout: PropTypes.string.isRequired,
};

export default FilterLayout;
